import { WeatherSettingsChangeSource } from '@fe/weather';
import { useSliderSetting } from './hooks/useSetting';
import ZoomLevelSlider from '../../../../app/components/inputs/ZoomLevelSlider';

export default function SigWxSettings() {
    const tagsMinZoomLevel = useSliderSetting('sigWx', 'labelsMinZoomLevel', WeatherSettingsChangeSource.sigWx);
    return (
        <div className="d-flex gap-2 flex-column">
            <div className="d-flex gap-2 align-items-center">
                <ZoomLevelSlider className="flex-grow-1" {...tagsMinZoomLevel} />
            </div>
        </div>
    );
}
